import { useState } from 'react';
import { Button, Grid, Box, Typography, Alert, } from '@mui/material';
import {  formToJson} from '../../../Utils/Common';
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';
import CourseCategorySelector from '../../fragement/CourseCategorySelector';
import { CourseSelect } from '../../fragement/CourseSelector';
import { MyTextField, SingleSelector } from '../../../Component/MuiEx';

const EditCoursePackage = (props) => {
    const {data,onSubmit,onClose} = props
    const [fieldErrors, setFieldErrors] = useState()    
    const [fields,setFields] = useState({billtype:0})
    const [error, setError] = useState()
    // const session = getUserSession(apis)

    const handleSubmit = (event) => {
        setFieldErrors()
        setError()
        event.preventDefault();
        const form = new FormData(event.currentTarget);
        const postData = formToJson(form)
        postData.id = data ? data.id:0        
        postData.category_id = fields.category_id
        postData.course_id = fields.course_id
        postData.billtype = fields.billtype
        onSubmit && onSubmit(postData,setError,setFieldErrors)
    };
    return (
        <Container component="main" maxWidth="sm">
            <CssBaseline />
            <Box sx={{ marginTop: 12, display: 'flex', flexDirection: 'column', alignItems: 'center', }}>
                <Typography component="h1" variant="h5">Define Course Package</Typography>
                <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3 }} autoComplete="off">
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12}>
                            <CourseCategorySelector defaultValue={0} name={"category_id"} onChange={(k, v) => { setFields({ ...fields, category_id: v != null ? v.id : 0}); }} />
                        </Grid>  
                        <Grid item xs={12} sm={12}>
                            <CourseSelect categoryid={fields.category_id} defaultValue={0} name={"course_id"}  onChange={(k, v) => { setFields({ ...fields, course_id: v != null ? v.id : 0}); }} />
                        </Grid> 
                        <Grid item xs={12} sm={12}>
                            <SingleSelector items={["Lesson","Time"]} defaultValue={0} values={[0,1]} label={"Billing Type"} onChange={(k,v)=>{setFields({...fields,billtype:v})}} />
                        </Grid>                              
                        <Grid item xs={12} sm={12}>
                            <MyTextField defaultValue={0} name="minutes" fullWidth={true} required={true} id="minutes" label="Minutes per lesson or 60 for time-mode"
                                fieldErrors={fieldErrors}/>
                        </Grid> 
                        <Grid item xs={12} sm={12}>
                            <MyTextField defaultValue={0} name="price" fullWidth={true} required={true} id="price" label="price / lesson or hour"
                                fieldErrors={fieldErrors}/>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <MyTextField defaultValue={0} name="tax" fullWidth={true} required={true} id="Tax" label="Set tax (0.13) if necessary"
                                fieldErrors={fieldErrors}/>
                        </Grid>   
                        <Grid item xs={12} sm={12}>
                            <MyTextField defaultValue={""} name="description" fullWidth={true} multiline={true} rows={3} id="description" label="Package description"
                                fieldErrors={fieldErrors}/>
                        </Grid>                    
                    </Grid>

                    {error && <Alert severity="error">{error}</Alert>}
                    <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 1 }} > Submit </Button>
                    <Button type="button" fullWidth variant="outlined" sx={{ mt: 1, mb: 2 }} onClick={() => { props.onClose && props.onClose(false) }}> Cancel </Button>
                </Box>
            </Box>
        </Container>
    );
}
export default EditCoursePackage